import { render, staticRenderFns } from "./LibraryDetails.vue?vue&type=template&id=2d601324&"
import script from "./LibraryDetails.vue?vue&type=script&lang=js&"
export * from "./LibraryDetails.vue?vue&type=script&lang=js&"
import style0 from "./LibraryDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports